import { openDB } from 'idb';

const DB_NAME = 'offline-db';
const REQUESTS_STORE = 'pending-requests';
const DATA_STORE = 'cached-data';

const dbPromise = openDB(DB_NAME, 2, {
  upgrade(db) {
    if (!db.objectStoreNames.contains(REQUESTS_STORE)) {
      db.createObjectStore(REQUESTS_STORE, { keyPath: 'id', autoIncrement: true });
    }

    if (!db.objectStoreNames.contains(DATA_STORE)) {
      db.createObjectStore(DATA_STORE);
    }
  }
});

//REQUEST_STORE
export async function queueRequest(request) {
  const db = await dbPromise;
  await db.add(REQUESTS_STORE, request);
}

export async function getAllQueued() {
  const db = await dbPromise;
  return db.getAll(REQUESTS_STORE);
}

export async function clearRequest(id) {
  const db = await dbPromise;
  await db.delete(REQUESTS_STORE, id);
}

//DATA_STORE
export async function cacheData(key, data) {
  const db = await dbPromise;
  await db.put(DATA_STORE, data, key);
}

export async function getCachedData(key) {
  const db = await dbPromise;
  return db.get(DATA_STORE, key);
}

export async function removeCachedData(key) {
  const db = await dbPromise;
  await db.delete(DATA_STORE, key);
}
